import { useEffect, useState } from "react"
import Swal from "sweetalert2";
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../../toastify/config";
import { Autocomplete, Box, Button, FormControl, IconButton, InputLabel, MenuItem, Modal, Paper, Select, TextField } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useLoginStore } from "../../../store/zustend";
import apiSafibc from "../../../axios/axios";
import LoadingSpinner from "../../Blog/Spinner";
import BadgeIcon from '@mui/icons-material/Badge';
import imageCompression from "browser-image-compression";

const styleCi = {
    position: 'absolute',
    top: '10%',
    left: '50%',
    transform: 'translateX(-50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '5px',
    width: '75%',
    maxHeight: '80vh', // Limita altura al 80% de la pantalla
    overflowY: 'auto', // Scroll vertical si se excede
};

const Clientes = () => {

    const [clientes, setClientes] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [clienteSelect, setClienteSelect] = useState()
    const [clienteSelectId, setClienteSelectId] = useState()
    const [modalEditarCliente, setModalEditarCliente] = useState(false)
    const [modalEditarIne, setModalEditarIne] = useState(false)

    const [ineFrente, setIneFrente] = useState('')
    const [ineReverso, setIneReverso] = useState('')
    const [anioVigencia, setAnioVigencia] = useState(0)
    const [ineFrenteReemplazo, setIneFrenteReemplazo] = useState(false)
    const [ineReversoReemplazo, setIneReversoReemplazo] = useState(false)

    const { loginStore } = useLoginStore()


    const clientesPagare = () => {

        const clientes = async () => {
            setIsLoading(true)
            try {
                const buscar = await apiSafibc.get('/clientes/clientes', {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setClientes(buscar.data)
                setIsLoading(false)
            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar clientes, favor de volver a cargar!'
                    }
                }
                setIsLoading(false)
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }

        }

        clientes()

    }

    useEffect(() => {
        clientesPagare()
    }, [])


    const consultarCliente = (clienteId) => {

        const buscarCliente = async (idc) => {
            try {
                setIsLoading(true)
                const ic = btoa(idc)

                const cargarCliente = await apiSafibc(`/clientes/info-cliente/${ic}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setClienteSelect(cargarCliente.data)
                setClienteSelectId(clienteId)

                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar informacion de cliente, favor de volver a cargar!'
                    }
                }
                setIsLoading(false)
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }

        buscarCliente(clienteId)
    }

    const handleChange = (e, id) => {
        e.preventDefault()

        consultarCliente(id)
    }

    const buscarIne = (e, ic) => {


        const buscandoIne = async () => {
            setIsLoading(true)
            try {

                const imgIne = await apiSafibc.get(`/clientes/img-ine/${btoa(ic)}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                const { imgFrente, imgReverso, anioVigencia } = imgIne.data

                setIneFrente(imgFrente)
                setIneReverso(imgReverso)
                setAnioVigencia(anioVigencia)
                setModalEditarIne(true)

                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar INE de cliente, favor de volver a cargar!'
                    }
                }
                setIsLoading(false)
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }

        }

        buscandoIne()

    }

    const leerINE = async (e, tipo) => {

        const { name, files } = e.target;
        const file = files[0];

        if (!file) return;

        // validar tipo
        if (!file.type.startsWith("image/")) {
            toast.error("El archivo debe ser una imagen", toast_config);
            return;
        }

        // validar tamaño original
        if (file.size > 1 * 1024 * 1024) {
            toast.error("La imagen no debe exceder 1MB", toast_config);
            return;
        }

        try {
            const compressedFile = await imageCompression(file, {
                maxSizeMB: 0.4,          // Máximo 400 KB
                maxWidthOrHeight: 1500,  // Redimensiona si es necesario
                initialQuality: 0.8,
                useWebWorker: true
            });

            /*console.log(
                `Original: ${(file.size / 1024).toFixed(1)} KB`
            );
            console.log(
                `Comprimida: ${(compressedFile.size / 1024).toFixed(1)} KB`
            );*/

            if (compressedFile.size > 500 * 1024) {
                toast.error("No fue posible reducir suficientemente la imagen", toast_config);
                return;
            }


            if (tipo == 'F') {
                setIneFrenteReemplazo(compressedFile)
            } else {
                setIneReversoReemplazo(compressedFile)
            }

        } catch (error) {
            console.error(error);
            toast.error("No fue posible procesar la imagen", toast_config);
        }



    }

    const reemplazarIne = (e, tipo) => {

        const reemplazar = async () => {
            setIsLoading(true)
            try {

                const jIne = {
                    tipo,
                    img: tipo == 'F' ? ineFrenteReemplazo : ineReversoReemplazo,
                    id_ahorrador: clienteSelectId
                }

                const reemplazando = await apiSafibc.put(`/clientes/reemplazar-ine`, jIne, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setIsLoading(false)

                setModalEditarIne(false)

                Swal.fire({
                    icon: 'success',
                    title: 'Enhorabuena!',
                    text: reemplazando.mensaje
                })

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al reemplazar imagen, favor de volver a intentarlo!'
                    }
                }
                setIsLoading(false)
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }

        }

        reemplazar()

    }


    return (
        <div className="container">
            {isLoading ?
                <LoadingSpinner />
                : null}
            <div className="row">
                <div className="col-md-12">

                    <div className="card shadow">
                        <div className="card-body">
                            <div className="row">
                                <div className='col-md-6 mb-5'>
                                    <FormControl variant="standard" sx={{ minWidth: '100%' }}>

                                        <Autocomplete
                                            disablePortal
                                            options={clientes.map((cliente) => ({ id: cliente.id_cliente, label: `${cliente.nombre} ${cliente.paterno} ${cliente.materno ?? ''}` }))}
                                            onChange={(event, cliente) => {
                                                if (!cliente) return
                                                handleChange(event, cliente.id)
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Cliente" variant='standard' />}
                                        />


                                    </FormControl>
                                </div>

                            </div>

                            <div className='table-responsive'>

                                <table className="table">
                                    <thead className='text-center'>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Apellido Paterno</th>
                                            <th>Apellido Materno</th>
                                            <th>Celular</th>
                                            <th>Direccion</th>
                                            <th>Ine</th>
                                            <th>Editar</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-center'>
                                        {clienteSelect &&
                                            <tr className='animation' key={clienteSelect.id_cliente}>
                                                <td>{clienteSelect.nombre}</td>
                                                <td>{clienteSelect.paterno}</td>
                                                <td>{clienteSelect.materno}</td>
                                                <td>{clienteSelect.cel}</td>
                                                <td>{clienteSelect.direccion}</td>
                                                <td>
                                                    <Button variant="contained" onClick={(e) => buscarIne(e, clienteSelect.id_cliente)}>
                                                        <BadgeIcon />
                                                    </Button>
                                                </td>
                                                <td>
                                                    <Button variant='contained' onClick={(e) => setModalEditarCliente(true)}>
                                                        <EditIcon />
                                                    </Button>
                                                </td>
                                            </tr>

                                        }
                                    </tbody>

                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />


            <Modal
                open={modalEditarIne} onClose={() => setModalEditarIne(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleCi}>
                    <div className='nav-header2 pt-4'></div>
                    <div className='card'>
                        <div className='card-header text-center'>
                            <h3>Editar INE</h3>
                        </div>
                        <div className='card-body'>
                            <div className='row'>
                                <div className="col-md-6 mb-3 d-flex flex-column align-items-center justify-content-center">

                                    <div
                                        style={{
                                            height: 320,
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginBottom: 16
                                        }}
                                    >
                                        <img
                                            src={`data:image/png;base64,${ineFrente}`}
                                            alt=""
                                            style={{
                                                maxHeight: "100%",
                                                maxWidth: 250,
                                                objectFit: "contain"
                                            }}
                                        />
                                    </div>

                                    <TextField
                                        type="file"
                                        name="frente"
                                        variant="standard"
                                        label="INE Frente"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ accept: "image/*" }}
                                        onChange={(e) => leerINE(e, "F")}
                                        fullWidth
                                        sx={{ mb: 3 }}
                                    />

                                    <Button
                                        variant="contained"
                                        onClick={reemplazarIne}
                                    >
                                        Reemplazar INE Frente
                                    </Button>

                                </div>
                                <div className='col-md-6 mb-3 text-center d-flex flex-column align-items-center justify-content-center'>
                                    <div
                                        style={{
                                            height: 320,
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginBottom: 16
                                        }}
                                    >
                                        <img
                                            src={`data:image/png;base64,${ineReverso}`}
                                            alt=""
                                            style={{
                                                maxHeight: "100%",
                                                maxWidth: 250,
                                                objectFit: "contain"
                                            }}
                                        />
                                    </div>

                                    <TextField
                                        type="file"
                                        name="frente"
                                        variant="standard"
                                        label="INE Reverso"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ accept: "image/*" }}
                                        onChange={(e) => leerINE(e, "R")}
                                        fullWidth
                                        sx={{ mb: 3 }}
                                    />

                                    <Button variant="contained">Reemplazar Ine Reverso</Button>

                                </div>
                                <div className="col-md-12">
                                    <TextField type="number" className="mb-3" variant="standard" value={anioVigencia} label='Anio Vencimiento Ine' /> <br />
                                    <Button variant="contained">Guardar Vencimiento</Button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Box>

            </Modal>



        </div>
    )
}

export default Clientes